import { Link } from 'react-router'

const Notfound: React.FC = () => (
  <section className="text-center">
    <h1 className="mb-2 text-3xl font-semibold">404</h1>
    <p className="text-gray-600">Page not found.</p>
    <p className="mt-4">
      <Link to="/" className="text-blue-600 hover:underline">
        Back to home
      </Link>
    </p>
  </section>
)

export default Notfound
